import styled from "@emotion/styled";
import Chip, { chipClasses } from "@mui/material/Chip";

interface StyledChipProps {
	hasWarning: boolean | undefined;
}

export const StyledFilterChip = styled(Chip, {
	shouldForwardProp: (prop) => prop !== "hasWarning"
})<StyledChipProps>(({ hasWarning }) => ({
	marginRight: "0.5rem",
	maxWidth: "270px",
	"& .MuiChip-deleteIcon": {
		height: "24px"
	},
	...(!hasWarning && {
		[`&.${chipClasses.root}`]: {
			"&:hover": {
				color: "var(--cwg-blue-900)",
				borderColor: "var(--chip-selected)"
			}
		}
	}),
	[`.${chipClasses.label}`]: {
		fontSize: ".938rem",
		maxWidth: "200px"
	},
	[`.${chipClasses.deleteIcon}`]: {
		...(hasWarning && {
			color: "var(--orange-500)",
			":hover": {
				color: "var(--orange-500)"
			}
		}),
		...(!hasWarning && {
			color: "var(--cwg-blue-900)",
			"&:hover": {
				color: "var(--cwg-blue-900)"
			}
		})
	},
	[`&.${chipClasses.colorPrimary}`]: {
		backgroundColor: "var(--white-50)",
		borderStyle: "solid",
		borderWidth: 1,
		fontWeight: 500,
		...(hasWarning && {
			color: "var(--orange-500)",
			borderColor: "var(--orange-500)"
		}),
		...(!hasWarning && {
			color: "var(--text-primary)",
			borderColor: "var(--gray-400)"
		})
	},
	[`&.${chipClasses.colorSecondary}`]: {
		borderWidth: 1,
		borderStyle: "solid",
		fontWeight: 500,
		...(hasWarning && {
			color: "var(--orange-500)",
			backgroundColor: "var(--orange-50)",
			borderColor: "var(--orange-100)"
		}),
		...(!hasWarning && {
			color: "var(--cwg-blue-900)",
			backgroundColor: "var(--chip-selected)",
			borderColor: "var(--chip-selected)"
		})
	}
}));
